var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continer"},[_c('div',{staticClass:"center"},_vm._l((_vm.routerList),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.url,"active-class":"active","exact":""}},[_vm._v(_vm._s(item.label))])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }